/**
 * SIGN_URL
 */
export const S3_SIGN_URL = 'S3.SIGN_URL';
export const S3_SIGN_URL_SUCCESS = 'S3.SIGN_URL_SUCCESS';
export const S3_SIGN_URL_ERROR = 'S3.SIGN_URL_ERROR';